import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../shared/local-storage.service';
import { HMSDelivery } from '../shared/hms-delivery.model';

@Component({
    selector: 'app-hms-draft',
    templateUrl: './hms-draft.component.html',
    styleUrl: './hms-draft.component.css',
    standalone: false
})
export class HmsDraftComponent {

  drafts: HMSDelivery[] = [];
  draftsSubscription!: Subscription;
  user = LocalStorageService.current_user;
  
  
  constructor(public router: Router) { }
  
  ngOnInit(): void {
    LocalStorageService.storage_promise.then(_ => {
      this.drafts = LocalStorageService.hms_drafts;
      console.log(this.drafts)
      this.draftsSubscription = LocalStorageService.hms_drafts$.subscribe(val => this.drafts = val);    
    });
  }
  
   onDraftClick(index: number) {
      this.router.navigate(['hms_delivery_detail', 3, index], { queryParams: { previous: 'hms_drafts' } })
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
    }
  
  
    ngOnDestroy(): void {
      if (this.draftsSubscription) this.draftsSubscription.unsubscribe();
    }
}
